/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type DomainUiLightDto = {
    id: string;
    isAllDomain: boolean;
    name: string;
    parentDomainId?: string;
    role: DomainUiLightDto.role;
};

export namespace DomainUiLightDto {

    export enum role {
        EDITOR = 'Editor',
        MONITOR_RESPONDER = 'Monitor responder',
        CATALOG_EDITOR = 'Catalog editor',
        VIEWER = 'Viewer',
    }


}
